export class RegionHelper{
    static getRegion(){
        //とりあえず今は常にJPを返す
        return "JP"
    }
}